export class UserSettings {

    public id : string = '';
    
    public topics : string[] = [];

}

export class UserSettingEntry {

    public id : string = '';

    public display: string = '';

    public topics : UserSettingsEntryTopic[] = [];

}

export class UserSettingsEntryTopic {

    public display: string = '';

    public description : string = '';

    public value : string = '';

    public enabled : boolean = false;

}

export class UserSettingsUpdate {

    public topics: string[] = [];

}
